import { ITuileNav } from '@/models/ui/ITuileNav'
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloConfigActivity, getDefaultAloConfigActivity } from './AloConfigActivity'
import { AloMedia, cleanAloMedia, getDefaultAloMedia } from './AloMedia'
import { AloPageContent, getDefaultAloPageContent } from './AloPageContent'
    
export interface AloActivity extends AloBase {                
    pagId:number
    acyEnfant:boolean
    acyInfos:string
    acyOrdre:number|null
    acyAge:number|null
    image:AloMedia
    images:Array<AloMedia>
    content:AloPageContent
    config:string
    configActivity:AloConfigActivity
}

export const getDefaultAloActivity = ():AloActivity => {
    return {  
        ...getDefaultAloBase(),
        pagId:0,
        acyEnfant:false,
        acyInfos:"",
        acyOrdre:null,
        acyAge:null,
        image:getDefaultAloMedia(),
        images:[],
        content:getDefaultAloPageContent(),
        config:'',
        configActivity:getDefaultAloConfigActivity()
    }
}

export const cleanAloActivity = (activity:AloActivity) => {
    if(!activity) return    
    if(!activity.id) delete activity.id
    if(!activity.pagId) delete activity.pagId    
    cleanAloMedia(activity.image)
    activity.images?.forEach(i => cleanAloMedia(i))
    activity.config = JSON.stringify(activity.configActivity)
    delete activity.configActivity
}

export const ConvertToTuileNav = (activity:AloActivity):ITuileNav => {
    return {
        id: activity.id,  
        title: activity.libelle,
        image: activity.image,
        subtitle: activity.acyInfos,
        promo: activity.acyAge == 0?"A partir de 6 mois":(activity.acyAge?`A partir de ${activity.acyAge} ans`:""),
        to: {name:activity.acyEnfant?'ActiviteEnfant':'ActiviteAdulte',params:{activityId:activity.id.toString(),slug:activity.content.slug}}
    }
}  